import React from 'react';
import { ModuleBaseNameProps } from '@/types';
import { Box, Stack } from '@/components';
import { animControllerInView, scaleIn } from '@/animations';
import { StatElementModel } from '@/types/StatElementModel';
import classNames from 'classnames';

export type InfoBlockStatsModuleModel = {
  text?: string;
  statElements: StatElementModel[];
} & ModuleBaseNameProps &
  React.HTMLAttributes<HTMLDivElement>;

const InfoBlockStatsModule = ({ statElements }: InfoBlockStatsModuleModel) => {
  return (
    <Stack animation={animControllerInView({ amount: 0.3 })} className="info-block-stats flex flex-wrap lg:w-1/2">
      {statElements.map((statElement, index) => (
        <div
          key={index}
          className={classNames(
            'relative flex w-1/2 flex-col border-[#adadad] p-3 even:border-l md:p-5 lg:p-9',
            index !== 0 && index !== 1 && 'after-extended-line-top after:right-0 after:left-[unset] after:bg-[#adadad]',
          )}
        >
          <Box animation={scaleIn} className="flex flex-col gap-1 md:gap-2 lg:gap-5">
            <div className="text-style-h2">{statElement.numericValue}</div>
            <div className="text-style-body">{statElement.description}</div>
          </Box>
        </div>
      ))}
    </Stack>
  );
};

export default InfoBlockStatsModule;
